export const FETCH_ORDER_COUNT_INSIGHTS_SUCCESS = 'fetch_order_count_insights_success'
export const FETCH_ORDER_AMOUNT_INSIGHTS_SUCCESS = 'fetch_order_amount_insights_success'
